import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {UploadFileListComponent} from './upload-file-list.component';

@NgModule({
  declarations: [
    UploadFileListComponent
  ],
  imports: [
    CommonModule,
    MatProgressBarModule,
    MatTooltipModule
  ],
  exports: [
    UploadFileListComponent
  ]
})
export class UploadFileListModule { }
